import React, {Dispatch, SetStateAction, useContext, useState} from "react";
import {X, Save, CheckCircleFill, DashCircleFill, Trash} from "react-bootstrap-icons";
import {ProductNotification} from "../../Views/OffersView/OffersView";
import CButton from "../Button/CButton";
import {Api} from "../../RequestsProvider/RequestProvider";
import {toast} from "react-toastify";
import {Context} from "../../ContextProvider/Context";
import './TableRow.css';
const TableRow = (props:{
    item: ProductNotification,
    getProductNotifications: () => Promise<void>,
    setShowModal: Dispatch<SetStateAction<boolean>>
    setProductNotificationsToDelete: Dispatch<SetStateAction<ProductNotification | undefined>>
}) => {

    const [productName, setProductName] = useState(props.item.productName)
    const [changeProductName, setChangeProductName] = useState(false)
    const [isNotificationChangeLoading, setIsNotificationChangeLoading] = useState(false)
    const [activeNotification, setActiveNotification] = useState(props.item.activeNotification)

    const request = useContext(Api)
    const context = useContext(Context)
    const {updateProductNotification} = request!
    const {setContentLoading} = context!

    const update = ()=>{
        setIsNotificationChangeLoading(true)
        setTimeout(()=>{
            updateProductNotification(props.item).then((response) => {
                setContentLoading(false)
                if(response.message){
                    setActiveNotification(props.item.activeNotification)
                    setChangeProductName(false)
                }else{
                    toast(`Das Produkt konnte nicht aktualisiert werden. 😔`)
                }
                setIsNotificationChangeLoading(false)
            })
        }, 1000)
    }
    const initials = props.item.productName.split(" ").map((word: string) => word.charAt(0)).join("").toUpperCase()
    return (
        <tr key={props.item.id} className={`table-row ${isNotificationChangeLoading?'tr-active-loading' : null} no-pointer`}>
            <td className="border-radius-left">
                <div className="flex">
                    <div style={{background: '#4ceb9c'}}
                         className="circle-colored">
                        <div>{initials}</div>
                    </div>
                    <div className="row g-0 align-items-center">
                        {changeProductName ? <><div className="col-auto">
                                <input value={productName}
                                       placeholder={"Gib einen Produktnamen ein"}
                                       className="employee-search border"
                                       type="text"
                                       onChange={(event: { target: { value: SetStateAction<string> } }) => {
                                           setProductName(event.target.value)
                                       }}/>
                            </div>
                            <div className="col-auto">
                                <CButton content={"Speichern"} icon={<Save/>} onClick={() => {
                                    props.item.productName = productName
                                    update()
                                }}/>
                                <CButton content={"Abbruch"} icon={<X/>} onClick={() => {setChangeProductName(false)}}/>
                            </div></> : <div onClick={()=>setChangeProductName(true)} className="mx-2 col-auto pointer">{productName}</div>
                    }

                </div>
                </div>
            </td>
            <td onClick={() => {
                props.item.activeNotification = !props.item.activeNotification
                update()
            }} className={"text-truncate pointer"}>{!isNotificationChangeLoading ? (activeNotification ?
                    <CheckCircleFill className={"text-success"}/> : <DashCircleFill className={"text-danger"}/>) :
                <div className="spinner-border spinner-border-sm circle-loading" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>}</td>
            <td onClick={() => {
                props.setProductNotificationsToDelete(props.item)
                props.setShowModal(true)
            }} className="border-radius-right pointer"><Trash className={"text-danger"}/></td>
        </tr>)
}

export default TableRow
